import { render, staticRenderFns } from "./RasporedOdvoza.vue?vue&type=template&id=4a6b5518"
import script from "./RasporedOdvoza.vue?vue&type=script&lang=js"
export * from "./RasporedOdvoza.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EditorTipTap: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorTipTap.js').default,UiDeliveryScheduleSearch: require('/home/node/app/components/ui/deliveryScheduleSearch.vue').default,UiInputComponent: require('/home/node/app/components/ui/inputComponent.vue').default,UiPrimaryButton: require('/home/node/app/components/ui/primaryButton.vue').default,UiIconsChecked: require('/home/node/app/components/ui/icons/checked.vue').default,UiIconsChevron: require('/home/node/app/components/ui/icons/chevron.vue').default,UiIconsTooltip: require('/home/node/app/components/ui/icons/tooltip.vue').default,EditorImage: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorImage.js').default,UiIconsLink: require('/home/node/app/components/ui/icons/link.vue').default,EditorList: require('/home/node/app/node_modules/@gauss/cms-core/lib/components/editors/EditorList.js').default})
